
  <!-- <section class="section_area section_inner section_innertop section_innerbottom"> -->
		<!-- <div  v-bind:class="pass.class">
			<a class="page_con prev" v-on:click="onClickPagerPreNo('N',pass.pageNo)" v-bind:href="pass.href" >이전 페이지</a>
				<div class="number">
				    <input type="number" v-model="pass.pageNo" class="form_style">
							/
				    <span class="total">{{pass.endSize}}</span>
				</div>
			<a class="page_con next" v-on:click="onClickPagerNxtNo('Y',pass.pageNo)" v-bind:href="pass.href">다음 페이지</a>
		</div> -->
	<!-- </section> -->

    <div v-bind:class="pass.class">
      <a class="page_con first" v-bind:href="pass.href" v-on:click="onClickPagerNo(0)" @keydown.enter.prevent="onClickPagerNo(0)" tabindex="9000">첫 페이지</a>
      <a class="page_con prev"  v-bind:href="pass.href" v-on:click="onClickPagerNo(pass.startBlock-1)" @keydown.enter.prevent="onClickPagerNo(pass.startBlock-1)" tabindex="9001">이전 페이지</a>
      <ul class="page_num">
        <li :class="{on:item == (pass.pageNo==0 ? 1:pass.pageNo)}" v-for="(item, index) in pass.list" v-bind:key="item">
          <a v-on:click="onClickPagerNo(item)" v-bind:href="pass.href" :tabindex="9002+index" @keydown.enter.prevent="onClickPagerNo(item)">{{item}}</a>
        </li>
      </ul>
      <a class="page_con next" v-bind:href="pass.href" v-on:click="onClickPagerNo(pass.nextBlock)" @keydown.enter.prevent="onClickPagerNo(pass.nextBlock)" tabindex="9020">다음 페이지</a>
      <a class="page_con last" v-bind:href="pass.href" v-on:click="onClickPagerNo(pass.endSize)" @keydown.enter.prevent="onClickPagerNo(pass.endSize)" tabindex="9021">마지막 페이지</a>
    </div>

